import { TRAVEL_TYPE_WITH_HOUSING } from '@repo/utils'
import clsx from 'clsx'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { TravelTypeModeEnum } from './travel-type-container/travel-type-container.enum'
import TravelTypeContainer from './travel-type-container/TravelTypeContainer'
import { getTravelTypeClassNameByEnum } from './travel-type-picker.utils'
import { translateTravelType } from '../../molecules/modal-select-proposal/components/modal-select-proposal-travel-type-button-group/travel-type-button/travel-type.utils'

const TravelTypePicker = ({
  className,
  mode = TravelTypeModeEnum.DEFAULT,
}: {
  className?: string
  mode?: TravelTypeModeEnum
}) => {
  return (
    <div className={clsx(s[getTravelTypeClassNameByEnum(mode)], className)}>
      {TRAVEL_TYPE_WITH_HOUSING.map((travelType) => (
        <TravelTypeContainer
          label={<FormattedMessage {...translateTravelType(travelType)} />}
          key={travelType}
          containerTravelType={travelType}
          mode={mode}
        />
      ))}
    </div>
  )
}

export default TravelTypePicker
